<div class="pt-3 pb-2 mb-3">
	<div class="shadow-lg p-3 mb-5 bg-white rounded table-responsive">
		<table *ngIf="payload" class="table table-hover">
			<thead>
				<tr>
					<th>ID</th>
					<th>Created At</th>
					<th>Kiosk</th>
					<th>Tx ID</th>
					<th>Range</th>
					<th>Offer</th>
					<th>Debit MSISDN</th>
					<th>Beneficiary MSISDN</th>
					<th>Payment</th>
					<th>Currency</th>
					<th>Amount</th>
					<th>Success</th>
					<th>Error</th>
					<th>TP</th>
					<th>Payment Success</th>
					<th>Payment Error</th>
					<th>Payment TP</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let data of payload">
					<th scope="row">{{data.id}}</th>
					<td>{{data.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
					<td>{{util.getKioskDetails(data.kiosk)}}</td>
					<td>{{data.txId}}</td>
					<td>{{data.range}}</td>
					<td>{{data.offer}}</td>
					<td>{{data.debitMsisdn}}</td>
					<td>{{data.beneficiaryMsisdn}}</td>
					<td>{{data.paymentType}}</td>
					<td>{{data.currency}}</td>
					<td>{{data.amount}}</td>
					<td><fa-icon [icon]="getIcon(data.success)" class="text-primary fs-4" [ngClass]="getIconClass(data.success)"></fa-icon></td>
					<td>{{data.error}}</td>
					<td>
						<button class="btn btn-outline-secondary" 
							(click)="viewTp(data); $event.stopPropagation()" 
							type="button"><fa-icon [icon]="view" size="lg"></fa-icon>
						</button>
					</td>
					<td>
						<fa-icon *ngIf="data.paymentSuccess !== undefined" [icon]="getIcon(data.paymentSuccess)" class="text-primary fs-4" [ngClass]="getIconClass(data.paymentSuccess)"></fa-icon>
					</td>
					<td>{{data.paymentError}}</td>
					<td>{{data.paymentResponseType}}</td>
					<td>
						<button class="btn btn-outline-secondary" 
							(click)="viewPaymentTp(data); $event.stopPropagation()" 
							type="button"><fa-icon [icon]="view" size="lg"></fa-icon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
